// Areas served by Melbourne Hand Center across Brevard County, FL
// Each entry powers an SEO-targeted city page at /areas-we-serve/:slug

const cityNames = [
  'Melbourne',
  'Palm Bay',
  'Titusville',
  'Cocoa',
  'Rockledge',
  'Merritt Island',
  'West Melbourne',
  'Cocoa Beach',
  'Cape Canaveral',
  'Satellite Beach',
  'Indian Harbour Beach',
  'Indialantic',
  'Melbourne Beach',
  'Malabar',
  'Grant-Valkaria',
  'Palm Shores',
  'Melbourne Village',
  'Mims',
  'Micco',
  'Port St. John',
  'Viera',
  'Sharpes',
  'Scottsmoor',
];

const toSlug = (name) =>
  name
    .toLowerCase()
    .replace(/\./g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

export const areasServed = cityNames.map((name) => ({
  name,
  slug: toSlug(name),
  state: 'FL',
  fullName: `${name}, FL`,
}));

export const getAreaBySlug = (slug) =>
  areasServed.find((area) => area.slug === slug);

// Common services & conditions shown on every city page
export const areaServices = [
  'Carpal Tunnel Treatment',
  'Trigger Finger Treatment',
  'Hand & Wrist Fracture Care',
  'Arthritis Treatment',
  'Tendon Injuries',
  'Nerve Injuries',
  'Hand Surgery',
];

export const areaConditions = [
  'Carpal Tunnel Syndrome',
  'Arthritis',
  'Fractures',
  'Tendon Injuries',
  'Nerve Compression',
];
